// Which excluded ids get the grey overlay. A user colour renders opaque over a ghost, so while something is
// isolated only the isolated ones are painted, and a focused type (the heatmap's pick) keeps its own colour.
export function excludedIdsToPaint(
  excludedIds: readonly string[],
  isolatedIds: readonly string[] | undefined,
  focusedIds: ReadonlySet<string>
): string[] {
  const isolated = isolatedIds?.length ? new Set(isolatedIds.map(String)) : null;
  return excludedIds.filter((objectId) => {
    const id = String(objectId);
    if (focusedIds.has(id)) return false;
    return !isolated || isolated.has(id);
  });
}
